<template>
  <div>
    <editor-stepper
    />
    <loader v-if="loading"
      :label="$t('editor.loadingDecisionPolicy')"
    />
    <v-container
      v-else
    >
      <decision-policy
        :decision-policy.sync="decisionPolicy"
        v-on="$listeners"
        @optionsUpdated="onOptionsUpdated"
        @optionsDeleted="onOptionsDeleted"
        @scenarioUpdated="onScenarioUpdated"
        @scenarioDeleted="onScenarioDeleted"
        @elementsUpdated="onElementsUpdated"
        @optionsCreated="onOptionsCreated"
        @scenarioCreated="onScenarioCreated"
        @raison-event="$emit('raison-event', $event)"
      />
    </v-container>
  </div>
</template>
<script>
import DecisionPolicy from '@/components/editor/DecisionPolicy'
import EditorStepper from '@/components/editor/EditorStepper'
import Loader from '@/components/global/Loader'

import pageableMixin from '@/mixins/pageable-mixin.js'

import decisionPolicyService from '@/services/decisionPolicy.js'
import helpService from '@/services/help.js'

export default ({
  name: 'Editor',
  
  components: {
    DecisionPolicy,
    EditorStepper,
    Loader
  },
  
  mixins: [ pageableMixin ],

  data () {
    return {
      loading: true,
      decisionPolicy: {},
    }
  },

  props: {
  },

  computed: {
  },

  methods: {
    getDecisionPolicy(projectId) {
      this.loading = true
      // console.log('get decision policy')
      decisionPolicyService.getDecisionPolicyWithMinimalScenariosOnly(projectId)
        .then(response => {
          this.decisionPolicy = response.data
        })
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] })
        })
        .finally(() => {
          this.loading = false
        });
    },
    onOptionsCreated(newOptions) {
      this.decisionPolicy.options.splice(0, 0, ...newOptions)
    },
    onOptionsUpdated(optionsUpdated) {
      // console.log('onOptionsUpdated', optionsUpdated)
      for(let option of optionsUpdated) {
        const index = this.decisionPolicy.options.findIndex(opt => opt.id === option.id)
        if(index != -1) {
          this.decisionPolicy.options.splice(index, 1, option)
        }
        else {
          console.log('option', option, 'not found')
        }
      }
    },
    onOptionsDeleted(optionsDeleted) {
      // console.log('onOptionsDeleted', optionsDeleted)
      for(var option of optionsDeleted) {
        const index = this.decisionPolicy.options.indexOf(option)
        if(index != -1) {
          this.decisionPolicy.options.splice(index, 1)
        }
      }
    },
    onScenarioCreated(scenario) {
      // console.log('onScenarioCreated', scenario)
      this.decisionPolicy.scenarios.splice(0, 0, {
        id: scenario.id,
        elements: scenario.elements.map(element => { return { id: element.id } }),
        level: scenario.level,
        preferences: []
      })
    },
    onScenarioUpdated(scenario) {
      // console.log('onScenarioUpdated', scenario)
      const scenarioIndex = this.decisionPolicy.scenarios.findIndex(sce => sce.id === scenario.id)
      const newScenario = {
        ...this.decisionPolicy.scenarios[scenarioIndex],
        elements: scenario.elements.map(elt => { return { id: elt.id }})
      }
      this.decisionPolicy.scenarios.splice(scenarioIndex, 1, newScenario)
    },
    onScenarioDeleted(scenario) {
      // console.log('onScenarioDeleted', scenario)
      const scenarioIndex = this.decisionPolicy.scenarios.findIndex(sce => sce.id === scenario.id)
      this.decisionPolicy.scenarios.splice(scenarioIndex, 1)
    },
    onElementsUpdated(elements) {
      // console.log('onElementsUpdated', elements)
      for(var element of elements) {
        const index = this.decisionPolicy.elements.findIndex(elt => elt.id === element.id)
        if(index !== -1) {
          this.decisionPolicy.elements.splice(index, 1, element)
        }
      }
    },
  },

  created () {
    this.projectId = this.$route.params.id
    this.getDecisionPolicy(this.projectId)
    helpService.setHelpPage(this.$store, 'editor_initial_scenarios')
  }
})
</script>
<style>
</style>